module.exports = __webpack_public_path__ + "img/fifa-logo.e32e7142.png";